<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <report-list :pid="$route.query.id"></report-list>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import reportList from "./report_info";

export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    reportList
  },
  data () {
    return {
      if_open: false,

      if_open1: false, //查看救助申请人详情
      apply_id: null, //救助人id

      report_id: null,
      approval_id: null,
      modal_title: null,
      disabled: false,
      apply_list_show: false, //救助列表
      report_name: null //报告名称
    };
  },

  methods: {
    // 查看报告
    look (row) {
      this.report_id = row.id;
      this.approval_id = row.approval_id;
      this.modal_title = row.project_name;
      this.disabled = true;
      this.if_open = true;
    },

    // 查看
    applyLook (id) {
      this.apply_id = id;
      this.if_open1 = true;
    },

    //查看报告救助人数
    showApplyList (row) {
      this.report_id = row.id;
      this.report_name = row.report_name;
      this.apply_list_show = true;
    },

    //编辑报告
    edit (row) {
      this.report_id = row.id;
      this.modal_title = row.project_name;
      this.approval_id = row.approval_id;
      this.disabled = false;
      this.if_open = true;
    }
  },
  mounted () { }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/info/report_list.vue